// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-card[data-v-be5ba598] {\n  background-color: #fff;\n  border-radius: 3px;\n  border-color: #e2e2e2;\n  width: 212px;\n  cursor: pointer;\n  margin-left: 4px;\n  position: absolute;\n  border-width: 1px;\n  border-style: solid;\n  margin-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
